import React from 'react';
import Icon from './Icon';
import '../styles/components/EmptyState.css';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
  compact?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action, compact }) => (
  <div className={`empty-state${compact ? ' empty-state--compact' : ''}`}>
    {icon && <Icon name={icon} size={compact ? 28 : 40} className="empty-state__icon" />}
    <p className="empty-state__title">{title}</p>
    {description && <p className="empty-state__desc">{description}</p>}
    {action && <div className="empty-state__action">{action}</div>}
  </div>
);

export default EmptyState;
